import React, { useRef, useState, useEffect } from "react";
import { RCCButton, RCCGrid, RCCHidden, RCCHookToast, RCCIcon, RCCServicesApi, RCCTooltip } from "react-common-components";
import Accordion, { CLASSNAME_ACCORDION_HEADER_SHOW_ONLY_ON_HOVER } from "src/components/Accordion";
import Photo from "src/components/Photo";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import formatDate from "src/utils/formatDate";
import { standardErrorMessages } from "src/utils/errors";
import { useHistory } from "react-router-dom";
import extractSingleValueFromArrayOfObject from "src/utils/extractSingleValueFromArrayOfObject";
import { ActionGroupers, ActionSituationFilter, IGrouperOfActions, IGroupersActions, IIntbb001BudgetGrouper, IListActions, IRefActionsModalBudget } from "./interface";
import ListOfActions, { IRefListOfActions } from "./listOfActions";
import { FilterButton, FilterButtonSelected, WrapTextWithoutLineClamp } from "./styles";
import ModalBudget from "./components/modalBudget";
import updateGrouperCountAction, { updateGrouperPercentAction } from "./updateGrouperAction";

const GrouperOfActions: React.FC<IGrouperOfActions> = ({
	grouper,
	layoutList,
	onCallbackAdd,
	children,
	filters,
	groupersSelect,
	header
}) => {
	const { setLoading: setLoadingBackdrop } = useLoaderBackdrop();
	const { addToast } = RCCHookToast();
	const { translate } = useTranslation();
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;

	const history = useHistory();

	const listOfActionsRef = useRef<IRefListOfActions>(null);
	
	const modalActionBudgetRef = useRef<IRefActionsModalBudget>(null);

	const [filterList, setFilterList] = useState<ActionSituationFilter | undefined>(undefined);
	const [grouperData, setGrouperData] = useState<IGroupersActions>(grouper);
	const [executeQuery, setExecuteQuery] = useState<boolean>(false);

	const filterActionsOnClickCountBar = (situation: ActionSituationFilter) => {
		let situationToUpdate: ActionSituationFilter | undefined = situation;
		
		if(filterList && filterList === situation)
			situationToUpdate = undefined;
		
		setFilterList(situationToUpdate);
	};

	const handleClickGroupers = async (_e: any, expanded: boolean) => {
		if(!expanded)
			return;

		setExecuteQuery(true);
	};

	const situationFilter = (situation: any) => {
		if(Array.isArray(situation))
			return extractSingleValueFromArrayOfObject("value", situation)?.toString();
		if(situation)
			return situation;
		return  "";
	};

	const showBudgetOfGrouper = async () => {
		try{
			setLoadingBackdrop(true);
			const {data} = await RCCServicesApi.getRequest({
				method: "Actions/Budget",
				urlParameters: {
					...groupersSelect,
					id: grouperData.id === 0 ? "" : grouperData.id,
					id2: grouperData.id2 || "",
					id3: grouperData.id3 || "",
					id4: grouperData.id4 || "",
					f: filters.f || "",
					responsible: filters.responsible || "",
					authority: filters.authority || "",
					consulted: filters.consulted || "",
					informed: filters.informed || "",
					sector: filters.sector || "",
					situation: situationFilter(filters.situation),
					startDate: filters.startDate ? formatDate(filters.startDate) : "",
					endDate: filters.endDate ? formatDate(filters.endDate) : ""
				}
			});
			const updateLabelMonth: IIntbb001BudgetGrouper[] = data.map((dt: IIntbb001BudgetGrouper) => ({
				...dt,
				name: translate(`monthWorkspace:${dt.name}`)
			}));
			setLoadingBackdrop(false);
			let title = translate(`actionWorkspace:${grouperData.title}`);
			if(grouperData.title2)
				title += ` -> ${translate(`actionWorkspace:${grouperData.title2}`)}`;
			if(grouperData.title3)
				title += ` -> ${translate(`actionWorkspace:${grouperData.title3}`)}`;
			if(grouperData.title4)
				title += ` -> ${translate(`actionWorkspace:${grouperData.title4}`)}`;

			modalActionBudgetRef.current?.actionButtonOpenBudget(title, updateLabelMonth);

		}catch(err){
			setLoadingBackdrop(false);
			standardErrorMessages(err, translate("Erro ao carregar orçamento"), addToast);
		}
	};

	const onCallbackUpdate = async (id: number, action: IListActions, prevSituation: string, prevPercent: number) => {
		setGrouperData((prevState) => {
			let updateState = {...prevState};
			updateState = updateGrouperCountAction(updateState, prevSituation, action.situation);
			updateState = updateGrouperPercentAction(updateState, prevPercent, action.inb001PercConclusao);
			return updateState;
		});
	};

	const onCallbackDelete = (inb001Id: number, situation: string, prevPercent: number) => {
		setGrouperData((prevState) => {
			let updateState = {...prevState};
			updateState = updateGrouperCountAction(updateState, situation, "");
			updateState = updateGrouperPercentAction(updateState, prevPercent, 0);
			return updateState;
		});
	};

	useEffect(() => {
		if(!executeQuery)
			return;
		listOfActionsRef.current?.executeQuery();
		setExecuteQuery(false);
	}, [executeQuery]);

	return (
		<>
			<Accordion 
				header={header ||
				<RCCGrid 
					container
					item 
					alignItems="center"
					justifyContent="space-between"
				>
					<span style={{ display: "flex", alignItems: "center", flex: 1, flexWrap: "wrap"}}>
						{grouperData.image !== null && (
							<Photo 
								hover
								name={grouperData.imageName || ""}
								link={grouperData.image !== "" ? `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${grouperData.image}` : ""}
							/>
						)}
						<WrapTextWithoutLineClamp>
							{translate(`actionWorkspace:${grouperData.title}`)}
						</WrapTextWithoutLineClamp>
						
						{grouperData.title2 !== null && grouperData.title2.length > 0 && (
							<>
								<RCCIcon name="arrowRight" size={20} />
								{translate(`actionWorkspace:${grouperData.title2}`)}
							</>
						)}
						{grouperData.title3 !== null && (
							<>
								<RCCIcon name="arrowRight" size={20} />
								{translate(`actionWorkspace:${grouperData.title3}`)}
							</>
						)}
						{ grouperData.title4 !== null && (
							<>
								<RCCIcon name="arrowRight" size={20} />
								{translate(`actionWorkspace:${grouperData.title4}`)}
							</>
						)}
					</span>
					<div style={{display: "flex", alignItems: "center", justifyContent: "flex-end",  minWidth: "100px"}} className={CLASSNAME_ACCORDION_HEADER_SHOW_ONLY_ON_HOVER}>
						{groupersSelect.group === ActionGroupers.RESPONSIBLE && (
							<RCCTooltip
								text={translate("Matriz de priorização")}
								color="grey"
							>
								<RCCButton
									color="grey"
									outlined
									layout="isRounded"
									size="xs"
									icon={{
										name: "dashboard"
									}}
									onClick={() => history.push(`/actions/matrix/${grouper.id}_${grouper.title}`)}
								/>
							</RCCTooltip>
						)}
						<RCCTooltip
							color="grey"
							text={translate("Mostrar Orçamento")}
						>
							<RCCButton 
								color="grey"
								outlined
								layout="isRounded"
								size="xs"
								icon={{
									name: "dollar"
								}}
								onClick={(e) => { e.stopPropagation(); showBudgetOfGrouper();}}
							/>
						</RCCTooltip>
						{children}
					</div>
					<RCCGrid container justifyContent="flex-end">
						{grouperData.draft > 0  && (
							<RCCButton 
								color="grey" 
								styleInline={filterList && filterList !== ActionSituationFilter.DRAFT ? FilterButtonSelected : FilterButton}
								onClick={(e) => { e.stopPropagation(); filterActionsOnClickCountBar( ActionSituationFilter.DRAFT); }}
							>{grouperData.draft} <RCCHidden only="xs">{translate("em rascunho")}</RCCHidden></RCCButton>
						)}
						{grouperData.canceled > 0  && (
							<RCCButton 
								color="grey" 
								styleInline={filterList && filterList !== ActionSituationFilter.CANCELED ? FilterButtonSelected : FilterButton}
								onClick={(e) => { e.stopPropagation(); filterActionsOnClickCountBar( ActionSituationFilter.CANCELED); }}
							>{grouperData.canceled} <RCCHidden only="xs">{translate("cancelada(s)")}</RCCHidden></RCCButton>
						)}
						{grouperData.delayed > 0  && (
							<RCCButton 
								color="red" 
								styleInline={filterList && filterList !== ActionSituationFilter.DELAYED ? FilterButtonSelected : FilterButton}
								onClick={(e) => { e.stopPropagation(); filterActionsOnClickCountBar( ActionSituationFilter.DELAYED); }}
							>{grouperData.delayed} <RCCHidden only="xs">{translate("atrasada(s)")}</RCCHidden></RCCButton>
						)}
						{grouperData.notStarted > 0  && (
							<RCCButton 
								color="purple" 
								styleInline={filterList && filterList !== ActionSituationFilter.NOT_STARTED ? FilterButtonSelected : FilterButton}
								onClick={(e) => { e.stopPropagation(); filterActionsOnClickCountBar( ActionSituationFilter.NOT_STARTED); }}
							>{grouperData.notStarted} <RCCHidden only="xs">{translate("não iniciada(s)")}</RCCHidden></RCCButton>
						)}
						{grouperData.nextToExpire > 0  && (
							<RCCButton 
								color="yellow" 
								styleInline={filterList && filterList !== ActionSituationFilter.NEXT_TO_EXPIRE ? FilterButtonSelected : FilterButton}
								onClick={(e) => { e.stopPropagation(); filterActionsOnClickCountBar(ActionSituationFilter.NEXT_TO_EXPIRE); }}
							>{grouperData.nextToExpire} <RCCHidden only="xs">{translate("a vencer")}</RCCHidden></RCCButton>
						)}
						{grouperData.started > 0 && (
							<RCCButton 
								color="blue" 
								styleInline={filterList && filterList !== ActionSituationFilter.IN_PROGRESS ? FilterButtonSelected : FilterButton}
								onClick={(e) => { e.stopPropagation(); filterActionsOnClickCountBar(ActionSituationFilter.IN_PROGRESS); }}
							>{grouperData.started} <RCCHidden only="xs">{translate("em andamento")}</RCCHidden></RCCButton>
						)}
						{grouperData.finished > 0 && (
							<RCCButton 
								color="green" 
								styleInline={filterList && filterList !== ActionSituationFilter.FINISHED ? FilterButtonSelected : FilterButton}
								onClick={(e) => { e.stopPropagation(); filterActionsOnClickCountBar(ActionSituationFilter.FINISHED); }}
							>
								{grouperData.finished} <RCCHidden only="xs">{translate("concluída(s)")}</RCCHidden>
							</RCCButton>
						)}
						<Title color="purple" size="sm" styleInline="margin 0 4px;">{translate("Andamento")}: {Math.round(grouperData.percentage || 0)}%</Title>
						<Title color="purple" size="sm" styleInline="margin 0 4px;">{translate("Total")}: {grouperData.count}</Title>
					</RCCGrid>
				</RCCGrid>
				}
				onChange={(e, expanded) => handleClickGroupers(e, expanded)}
			>		
				<ListOfActions 
					ref={listOfActionsRef}
					groupers={{
						grouperId: grouper.id, 
						grouperId2: grouper.id2, 
						grouperId3: grouper.id3, 
						grouperId4: grouper.id4
					}}
					filters={{
						...filters,
						situation: situationFilter(filters.situation)
					}}
					groupersSelect={groupersSelect}
					layoutList={layoutList}
					onCallbackUpdate={onCallbackUpdate}
					onCallbackAdd={onCallbackAdd}
					onCallbackDelete={onCallbackDelete}
					filterList={filterList}
					positionOptions="leftEnd"
					layout="withProgressBarPredicted"
				/>											
				
			</Accordion>
		
			<ModalBudget 
				ref={modalActionBudgetRef} 
			/>
		</>
	);
};

export default GrouperOfActions;
